export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13118.b4682ae0.jpg";